var render = function render(){var _vm=this,_c=_vm._self._c;return _c('basic-container',[_c('mc-empty-content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }